import GetAllAdminUsers from './GetAllAdminUsers';
import ChangeUserPassword from './ChangeUserPassword';
import ProfileUpdate from './ProfileUpdate';
import ResetPasswordCode from './ResetPasswordCode';
import Stripeonboarding from './Stripeonboarding';
import GetListOfStripeUsers from './getListofStripeUsers';
import CheckoutPayment from './CheckoutPayment';
import PricingEditor from './PricingEditor';
import PricingEditorUpdation from './PricingEditorUpdation';
import UpdateUsersPlan from './UpdateUsersPlan';
import FetchOrganizationDetails from './FetchOrganizationDetails';
import UpdateOrganizationDetails from './UpdateOrganizationDetails';
import GetOrganizationById from './GetOrganizationById';
import AuditLogs from './AuditLogs';
import PasswordManagement from './PasswordManagement';
import FetchAccountManager from './FetchAccountManager';
import PartnerIntegrations from './PartnerIntegrations';
const Settings = {
  GetAllAdminUsers: GetAllAdminUsers,
  ChangeUserPassword:ChangeUserPassword,
  ProfileUpdate:ProfileUpdate,
  ResetPasswordCode:ResetPasswordCode,
  Stripeonboarding:Stripeonboarding,
  GetListOfStripeUsers:GetListOfStripeUsers,
  CheckoutPayment:CheckoutPayment,
  PricingEditor:PricingEditor,
  PricingEditorUpdation:PricingEditorUpdation,
  UpdateUsersPlan:UpdateUsersPlan,
  FetchOrganizationDetails:FetchOrganizationDetails,
  UpdateOrganizationDetails:UpdateOrganizationDetails,
  GetOrganizationById:GetOrganizationById,
  AuditLogs:AuditLogs,
  PasswordManagement:PasswordManagement,
  fetchAccountManager: FetchAccountManager,
  partnerIntegrations: PartnerIntegrations,
};

export default Settings;